<template>
  <VuetiTable
    ref="table"
    class="tenders-table "
    :headers="choosedHeaders"
    item_key="tenderId"
    :items="convertItems"
    :selected.sync="choosed_items"
    @resizeMouseup="resizeMouseup">
    <template #[`header.bidsCount`]="{ header }">
      <sTooltip
        :border="false"
        :content="header.text"
        :open-delay="300"
        placement="bottom"
        popper-class="tender-bidsCount-tooltip info-tooltip"
        type="white">
        <sIcon
          color="var(--v-secondary__green_not_active-base)"
          type="person"/>
      </sTooltip>
    </template>
    <template #[`header.viewsCount`]="{ header }">
      <sTooltip
        :border="false"
        :content="header.text"
        :open-delay="300"
        placement="bottom"
        popper-class="tender-viewsCount-tooltip info-tooltip"
        type="white">
        <sIcon
          color="var(--v-secondary__green_not_active-base)"
          type="eye"/>
      </sTooltip>
    </template>
    <template #[`item.tenderSubject`]="{ item }">
      <div class="tender-name-wrapper flex">
        <CreatedInOldAccountChip
          v-if="item.hasRoute"
          chip-class="mr-2"
          mode="icon"
          :tender-id="item.tenderId"/>
        <router-link
          class="tender-name h7-text-medium"
          data-qa="href-tenderitem"
          :target="item.convertProps.target"
          :to="item.convertProps.link">
          <TooltipedText
            :line-count="3"
            :value="`#${item.tenderNumber}.  ${item.tenderSubject}`"/>
        </router-link>
        <sIcon
          v-if="item.convertProps.target"
          class="mt-1 ml-2"
          size="12"
          style="min-width: 20px"
          type="share"/>
      </div>
    </template>
    <template #[`item.categoryTitle`]="{ item }">
      <TooltipedText
        :line-count="3"
        :value="item.categoryTitle"/>
    </template>
    <template #[`item.organizer.title`]="{ item }">
      <span>
        {{ item.organizer ? item.organizer.title || '–': '–' }}
      </span>
    </template>
    <template #[`item.biddingTypeTitle`]="{ item }">
      <span>{{ item.biddingTypeTitle }}</span>
      <sChip
        v-if="item.isUrgent"
        background="var(--color-disabled)"
        color="black"
        :text="$t('Tenders.UrgentPurchase')"/>
    </template>
    <template #[`item.tenderStatusTitle`]="{ item }">
      <div class="flex flex-wrap flex-direction-column justify-center align-start">
        <StatusChip
          key-name="id"
          :status="getStatus(item)"
          value-name="title"/>
        <ListOfAcceptorsStages
          class="mt-2"
          data-qa="tender-card-list-of-acceptors"
          :item="item"
          :loading="load_agreement"
          only-status
          :stages="stages[item.tenderId] || []"
          @click-info="val => $emit('click-info', val)"/>
      </div>
    </template>
    <template #[`item.tenderingPeriodEnd`]="{ item }">
      <TenderDateTo
        class-name="flex-direction-column align-start  d-flex "
        :item="item"/>
    </template>
    <template #[`item.tenderCreatedDate`]="{ item }">
      {{ formatBy( item.tenderCreatedDate, date_format) }}
    </template>
    <template #[`item.archiveDate`]="{ item }">
      {{ formatBy( item.archiveDate, date_format) }}
    </template>
    <template #[`item.publishedDate`]="{ item }">
      <div
        v-if="item && item.convertProps.sheduledDate"
        class="flex">
        {{ formatBy(item.convertProps.sheduledDate, date_format) }}
        <v-tooltip
          bottom
          content-class="tooltip white black--text"
          open-delay="300">
          <template #activator="{ on }">
            <div
              v-on="on">
              <sButton
                class="ml-2"
                icon="time-ending"
                icon-size="18px"
                small
                type="text"/>
            </div>
          </template>
          <div class="text-left h8-text">
            {{ $t('Tenders.ScheduledPublication') }}
          </div>
        </v-tooltip>
      </div>
      <span v-else> {{ formatBy(item.publishedDate, date_format) }}</span>
    </template>
    <template #[`item.tenderBudjet`]="{ item }">
      <div class="tenderBudjet">
        {{ formSum( item.tenderBudjet ) }} {{ item.currencyTitle }}
      </div>
      <CurrencyConversionTooltip
        v-if="item.tenderBudjet"
        :currency="item.currencyTitle"
        :current-id="item.nbuCurrency ? item.nbuCurrency.currencyId : null"
        :nbu-currency="item.nbuCurrency"
        :price="item.tenderBudjet"/>
    </template>
    <template #[`item.bidsCount`]="{ item }">
      <component
        :is="item.bidsCount ? 'router-link' : 'div'"
        v-bind="item.bidsCount ? {to: {...item.convertProps.link, query: {tab: 'offers'}}, target: item.convertProps.target} : {}"
        data-qa="href-tenderitem">
        {{ item.bidsCount || '–' }}
      </component>
    </template>
    <template #[`item.viewsCount`]="{ item }">
      <component
        :is="item.viewsCount ? 'router-link' : 'div'"
        v-bind="item.viewsCount ? {to: {...item.convertProps.link, name: 'tenderVisits'}, target: item.convertProps.target} : {}"
        :class="{'grey--text': !item.viewsCount}"
        data-qa="href-tenderitem">
        {{ item.viewsCount || '–' }}
      </component>
    </template>
    <template #[`item.purchaseAmount`]="{ item }">
      {{ formSum(item.purchaseAmount) }} {{ item.currencyTitle }}
    </template>
    <template #[`item.economy`]="{ item }">
      {{ formSum(item.economy) }} {{ item.currencyTitle }}
    </template>
  </VuetiTable>
</template>
<script>
import StatusChip from 'components/common/elements/StatusChip.vue'
import VuetiTable from 'components/common/blocks/table/VuetiTable.vue'
import TenderDateTo from 'components/tenders/all tenders/TenderDateTo.vue'
import ListOfAcceptorsStages from 'components/agreement/ListOfAcceptorsStages.vue'
import CreatedInOldAccountChip from 'components/tenders/CreatedInOldAccountChip.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import CurrencyConversionTooltip from 'components/common/elements/CurrencyConversionTooltip.vue'

import { functionMixin, storageMixin, snackbarMixin, tenderMixin , modalMixin, userMixin, } from 'mixins'
export default {
  name: 'tendersTable',
  mixins: [ functionMixin, storageMixin, snackbarMixin , tenderMixin, modalMixin, userMixin],
  data() {
    return {
      date_format: 'DD.MM.YYYY, HH:mm'
    }
  },
  props: {
    choosedHeaders: Array,
    allHeaders: Array,
    items: Array,
    choosed: Array,
    group: Object,
    load_agreement: Boolean,
    stages: {
      type: Object
    }
  },
  computed: {
    convertItems() {
      if (!this.items?.length > 0) { return [] }

      return this.items?.map(item => {
        item.convertProps = {}
        item.convertProps.sheduledDate = this.getSheduledDate(item)
        item.convertProps.link = this.getLink(item)
        item.convertProps.target = item.organizer.organizationItId === this.storedCurrentOrganization.organizationItId && item.convertProps.link ? '' : '_blank'
        return item
      })
    },
    choosed_items: {
      get() {
        return this.choosed
      },
      set(value) {
        this.$emit('update:choosed', value)
      }
    },
  },
  methods: {
    getSheduledDate(item) {
      let scheduled = item?.tenderPublishedSchedule
      return item?.tenderStatusId == 1  && scheduled?.isScheduled && scheduled?.scheduledDate
    },
    getLink(item) {
      return  {name: 'tenderitem', params: { id: item.tenderId, org: item.organizer?.organizationItId ? item.organizer.organizationItId : this.$route.params.org}}
    },
    resizeMouseup(val, width) {
      this.choosedHeaders.find(el => {
        if (el.value == val) {
          el.resizedWidth = parseFloat( width )
          true
        }
      })
      this.$_savePropToDBStorage('tenders_headers', this.choosedHeaders)
    }
  },
  components: {
    StatusChip,
    VuetiTable,
    TenderDateTo,
    TooltipedText,
    ListOfAcceptorsStages,
    CreatedInOldAccountChip,
    CurrencyConversionTooltip
  }
}
</script>
<style lang="scss" scoped>
.tender-info {
  div {
    text-align: start;
    font-size: 13px;
  }
  .info-item-title {
    font-weight: 500;
  }
  .v-subheader {
    height: 15px;
  }
}
.tenderBudjet {
  word-break: break-word !important;
}
</style>
